import { render, staticRenderFns } from "./MakeupAllocated.vue?vue&type=template&id=43da0dcc"
import script from "./MakeupAllocated.vue?vue&type=script&lang=js"
export * from "./MakeupAllocated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports